var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNationalityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st1 {\n        fill: currentColor;\n        stroke: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NATIONALITY"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.58845,3.05239v53.89525c0,1.68515,1.36622,3.05236,3.05236,3.05236s3.05236-1.36721,3.05236-3.05236v-31.91866h35.66555c1.27977,0,2.42242-.79787,2.86358-1.99716.44314-1.20027.08943-2.5496-.88431-3.37827l-8.28867-7.06255,8.31252-7.23644c.96182-.83562,1.30163-2.17998.85649-3.37231-.44713-1.19233-1.58581-1.98225-2.85959-1.98225H10.64083c-1.68614,0-3.05236,1.36622-3.05236,3.05236"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNationalityIcon);
export default __webpack_public_path__ + "static/media/NationalityIcon.98f9d6a33c93bca5399062432ea295bf.svg";
export { ForwardRef as ReactComponent };